import { render } from "./Spare.vue?vue&type=template&id=a0e55a14&scoped=true"
import script from "./Spare.vue?vue&type=script&lang=js"
export * from "./Spare.vue?vue&type=script&lang=js"

import "./Spare.vue?vue&type=style&index=0&id=a0e55a14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e55a14"]])

export default __exports__